import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  metadata: {
    title: "Move Payment Ecommerce API Documentation",
    description: "Move Payment Documentation for the Ecommerce API",
    favicon: "/favicon.ico",
  },
  page: {
    logoUrl: "/icon.svg",
  },
  topNavigation: [
    { id: "docs", label: "Documentation" },
    { id: "api", label: "API Reference" },
  ],
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Overview",
        items: ["introduction"],
        collapsed: false,
      },
      {
        type: "category",
        label: "Receive payments",
        items: [
          "payment-gateway/payment-button",
        ],
        collapsed: false,
      },
      {
        type: "category",
        label: "Integration",
        items: [
          "integration/sandbox",
          "integration/api-keys",
          "webhooks/webhooks",
          "webhooks/signature",
        ],
        collapsed: false,
      },
      {
        type: "category",
        label: "Magento Plugin",
        items: [
          "plugins/magento/magento-step1",
          "plugins/magento/magento-step2",
          "plugins/magento/magento-step3",
        ],
        collapsed: false,
      },
      {
        type: "category",
        label: "WooCommerce Plugin",
        items: [
          "plugins/woocommerce/woocommerce-step1",
          "plugins/woocommerce/woocommerce-step2",
          "plugins/woocommerce/woocommerce-step3",
        ],
        collapsed: false,
      },
      {
        type: "category",
        label: "Shopware Plugin",
        items: [
          "plugins/shopware/shopware-step1",
          "plugins/shopware/shopware-step2",
          "plugins/shopware/shopware-step3",
          "plugins/shopware/shopware-step4",
        ],
        collapsed: false,
      },
      {
        type: "category",
        label: "JTL Plugin",
        items: [
          "plugins/jtl/jtl-step1",
          "plugins/jtl/jtl-step2",
          "plugins/jtl/jtl-step3",
          "plugins/jtl/jtl-step4",
        ],
        collapsed: false,
      }
    ],
  },
  redirects: [{ from: "/", to: "/docs/introduction" }],
  apis: {
    type: "url",
    input: "https://api.aws.movepayment.eu/ecommerce-json",
    navigationId: "api",
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};

export default config;
